import { useEffect } from "react";

/**
 * Update document.title and meta tags per page (Privacy, Terms, Admin).
 * Restores defaults on unmount.
 */
export default function usePageMeta({ title, description, canonical, noindex } = {}) {
  useEffect(() => {
    const prevTitle = document.title;
    const descTag = document.querySelector('meta[name="description"]');
    const prevDesc = descTag?.getAttribute("content");
    const robotsTag = document.querySelector('meta[name="robots"]');
    const prevRobots = robotsTag?.getAttribute("content");

    if (title) document.title = title;
    if (description && descTag) descTag.setAttribute("content", description);

    // Canonical
    let canonicalTag = document.querySelector('link[rel="canonical"]');
    const prevCanonical = canonicalTag?.getAttribute("href");
    if (canonical && canonicalTag) {
      canonicalTag.setAttribute("href", canonical);
    }

    // Noindex for admin pages
    if (noindex && robotsTag) {
      robotsTag.setAttribute("content", "noindex, nofollow");
    }

    return () => {
      if (title) document.title = prevTitle;
      if (description && descTag && prevDesc) descTag.setAttribute("content", prevDesc);
      if (canonical && canonicalTag && prevCanonical) canonicalTag.setAttribute("href", prevCanonical);
      if (noindex && robotsTag && prevRobots) robotsTag.setAttribute("content", prevRobots);
    };
  }, [title, description, canonical, noindex]);
}
